import {Injectable} from '@angular/core';
import {Autowired} from '@angular-ru/autowired';
import {BasicRestService} from '../../../core/services/basic-rest.service';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {RequestUtilities} from '../../../core/utilities/request-utilities';
import {HttpResponse} from '@angular/common/http';
import {IRecuperationListeDonneesRequete} from '@app/core/interfaces/actions/i-recuperation-liste-donnees-requete';

@Injectable({providedIn: 'root'})
export class UtilisateurAuthentifieRestApiService implements IRecuperationListeDonneesRequete {
    @Autowired() restService: BasicRestService;

    /**
     * :: TEST :: Recupère l'utilisateur authentifié
     *
     * @param data
     * @param args
     */
    requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
        return of({
            body: {
                'tenantId': 'e6fa8591-bec1-41ed-a13e-faf39fcc4671',
                'utilisateurId': 'f8b14b36-662d-4264-b19e-714e04edd7e6',
                'personne': {
                    'id': '3babe5dd-ed8a-4792-b496-7f5a898e7a86',
                    'adresse': {
                        'adressePostale': '01 BP 657 ABIDJAN 01',
                        'adresseGeographique': '01 BP 647 ABIDJAN 01',
                        'telephone1': '57555464',
                        'telephone2': '03977641',
                        'email': 'yajoel@hotmail.fr',
                        'emailSecondaire': 'jojodebaby@gmail.com',
                        'fax': '03 97 76 41',
                        'webSite': 'www.monsite.com',
                        'boitePostale': null
                    },
                    'logoUrl': null,
                    'nom': 'YA',
                    'prenom': 'JOEL',
                    'dateNaissance': '1991-01-10',
                    'genre': 'MASCULIN',
                    'civilite': 'MONSIEUR',
                    'fonction': 'INFORMATICIEN DEV APP',
                    'email': 'yajoel@hotmail.fr',
                    'adresseGeographique': '01 BP 647 ABIDJAN 01',
                    'adressePostale': '01 BP 657 ABIDJAN 01',
                    'emailSecondaire': 'jojodebaby@gmail.com',
                    'fax': '03 97 76 41',
                    'telephone1': '57555464',
                    'telephone2': '03977641',
                    'webSite': 'www.monsite.com'
                },
                'groupeUtilisateurs': [
                    {
                        'id': '788fbc76-eb26-4c91-8f77-a69909850053',
                        'libelle': 'GROUPE_UTILISATEUR_ROOT',
                        'description': 'GROUPE UTILISATEUR ROOT',
                        'statut': true,
                        'permissions': [
                            {
                                'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                'libelle': 'Administration',
                                'description': 'Administration',
                                'parent': null
                            }, {
                                'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                'libelle': 'Administration',
                                'description': 'Administration',
                                'parent': null
                            }, {
                                'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                'libelle': 'Administration',
                                'description': 'Administration',
                                'parent': null
                            }, {
                                'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                'libelle': 'Administration',
                                'description': 'Administration',
                                'parent': null
                            }, {
                                'id': '332fe2f5-4d5d-47ae-8e5f-3594dcdf936b',
                                'libelle': 'Administration.Gestion_des_habilitations',
                                'description': 'Gestion des habilitations',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': '332fe2f5-4d5d-47ae-8e5f-3594dcdf936b',
                                'libelle': 'Administration.Gestion_des_habilitations',
                                'description': 'Gestion des habilitations',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': '064d44d7-1ff3-4b1f-8136-b812a8eceead',
                                'libelle': 'Administration.Strategie_de_mot_de_passe',
                                'description': 'Strategie de mot de passe',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': '064d44d7-1ff3-4b1f-8136-b812a8eceead',
                                'libelle': 'Administration.Strategie_de_mot_de_passe',
                                'description': 'Strategie de mot de passe',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': '4ca2452e-1c8d-4a4b-a310-086799746ef5',
                                'libelle': 'Administration.Groupe_utilisateur',
                                'description': 'Groupe utilisateur',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': '4ca2452e-1c8d-4a4b-a310-086799746ef5',
                                'libelle': 'Administration.Groupe_utilisateur',
                                'description': 'Groupe utilisateur',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': 'ec0aadd8-a0b1-4018-af41-1f284db9f8be',
                                'libelle': 'Administration.Utilisateur',
                                'description': 'Utilisateur',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': 'ec0aadd8-a0b1-4018-af41-1f284db9f8be',
                                'libelle': 'Administration.Utilisateur',
                                'description': 'Utilisateur',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': 'e894871e-f9f1-4ec9-8a16-f208a1d067f2',
                                'libelle': 'Administration.Permission',
                                'description': 'Permission',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': 'e894871e-f9f1-4ec9-8a16-f208a1d067f2',
                                'libelle': 'Administration.Permission',
                                'description': 'Permission',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': '86cb01cc-1979-429e-b41c-ceda4396b8c4',
                                'libelle': 'Groupe_utilisateur.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': '4ca2452e-1c8d-4a4b-a310-086799746ef5',
                                    'libelle': 'Administration.Groupe_utilisateur',
                                    'description': 'Groupe utilisateur',
                                    'parent': {
                                        'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                        'libelle': 'Administration',
                                        'description': 'Administration',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '86cb01cc-1979-429e-b41c-ceda4396b8c4',
                                'libelle': 'Groupe_utilisateur.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': '4ca2452e-1c8d-4a4b-a310-086799746ef5',
                                    'libelle': 'Administration.Groupe_utilisateur',
                                    'description': 'Groupe utilisateur',
                                    'parent': {
                                        'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                        'libelle': 'Administration',
                                        'description': 'Administration',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '86cb01cc-1979-429e-b41c-ceda4396b8c4',
                                'libelle': 'Groupe_utilisateur.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': '4ca2452e-1c8d-4a4b-a310-086799746ef5',
                                    'libelle': 'Administration.Groupe_utilisateur',
                                    'description': 'Groupe utilisateur',
                                    'parent': {
                                        'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                        'libelle': 'Administration',
                                        'description': 'Administration',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'f7eabf55-d795-4149-9b4a-658f64a1c5c4',
                                'libelle': 'Permission.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'e894871e-f9f1-4ec9-8a16-f208a1d067f2',
                                    'libelle': 'Administration.Permission',
                                    'description': 'Permission',
                                    'parent': {
                                        'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                        'libelle': 'Administration',
                                        'description': 'Administration',
                                        'parent': null
                                    }
                                }
                            }
                        ]
                    },
                    {
                        'id': 'fc62b646-f3c6-4e17-b174-7f834323f40e',
                        'libelle': 'admin',
                        'description': 'admin',
                        'statut': false,
                        'permissions': [
                            {
                                'id': '5505579a-fa4d-4f39-a7e7-063cc2fb248d',
                                'libelle': 'Utilisateur.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': 'ec0aadd8-a0b1-4018-af41-1f284db9f8be',
                                    'libelle': 'Administration.Utilisateur',
                                    'description': 'Utilisateur',
                                    'parent': {
                                        'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                        'libelle': 'Administration',
                                        'description': 'Administration',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'b2dc2b02-a304-4818-a5af-a9e6c1693a1f',
                                'libelle': 'Opcvm.Saisir_un_placement_',
                                'description': 'Saisir un placement',
                                'parent': {
                                    'id': '02380b6c-2e95-44b4-8653-04c33ec078d5',
                                    'libelle': 'Titres.Opcvm',
                                    'description': 'Opcvm',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'b7474c5a-c302-4575-a7e8-ef7e52fdf464',
                                'libelle': 'Comptabilite',
                                'description': 'Comptabilite',
                                'parent': null
                            }, {
                                'id': '7acb7a39-619c-4e14-b4b1-ce53249de897',
                                'libelle': 'Jours_feries.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': 'b092c097-e1ff-45a4-992d-3a8e9e50017b',
                                    'libelle': 'General.Jours_feries',
                                    'description': 'Jours feries',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '5dad5a7a-c125-4221-ae83-549f825cad2a',
                                'libelle': 'Fonds.Waterfall',
                                'description': 'Waterfall',
                                'parent': {
                                    'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                    'libelle': 'Referentiel.Fonds',
                                    'description': 'Fonds',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '64c09a45-965f-43c7-aa03-a03e5f63211c',
                                'libelle': 'Portefeuille_du_fonds.Emission_de_titre',
                                'description': 'Emission de titre',
                                'parent': {
                                    'id': '436f77b5-6ec1-4660-a0b6-5ba28e2d0c26',
                                    'libelle': 'Portefeuille_du_fonds',
                                    'description': 'Portefeuille du fonds',
                                    'parent': null
                                }
                            }, {
                                'id': 'f0ff79ea-c49a-4dba-b65b-e64694071f73',
                                'libelle': 'Utilisateur.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'ec0aadd8-a0b1-4018-af41-1f284db9f8be',
                                    'libelle': 'Administration.Utilisateur',
                                    'description': 'Utilisateur',
                                    'parent': {
                                        'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                        'libelle': 'Administration',
                                        'description': 'Administration',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '9fdf295c-1c5a-4935-9467-4d1971b2f55f',
                                'libelle': 'Frais_de_fonctionnement.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': '7f082639-2a71-48e1-a8fc-e059f1ba6041',
                                    'libelle': 'Fonds.Frais_de_fonctionnement',
                                    'description': 'Frais de fonctionnement',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '0a0cf625-4452-48bb-9a55-da2ad2d1950b',
                                'libelle': 'Gestion_des_logs_de_consultation.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'cf9963d6-bc78-449a-a453-6f4daba0eb92',
                                    'libelle': 'Audit.Gestion_des_logs_de_consultation',
                                    'description': 'Gestion des logs de consultation',
                                    'parent': {
                                        'id': 'a503c966-ec21-4a89-9703-bada3dfb37cf',
                                        'libelle': 'Audit',
                                        'description': 'Audit',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'ebd7ef50-eaf1-4d22-8587-9721437f8983',
                                'libelle': 'Frais_de_fonctionnement.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '7f082639-2a71-48e1-a8fc-e059f1ba6041',
                                    'libelle': 'Fonds.Frais_de_fonctionnement',
                                    'description': 'Frais de fonctionnement',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'b27bc872-5f4b-47b5-8a32-41ccc8db6924',
                                'libelle': 'Jours_feries.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'b092c097-e1ff-45a4-992d-3a8e9e50017b',
                                    'libelle': 'General.Jours_feries',
                                    'description': 'Jours feries',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '540aa6f3-cb29-4792-ac55-416cee863ede',
                                'libelle': 'Reporting.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '7bd18539-e434-47b1-b746-010bea164a02',
                                    'libelle': 'Export.Reporting',
                                    'description': 'Reporting',
                                    'parent': {
                                        'id': '2488ac3b-4d5f-4084-827a-c7adf774d440',
                                        'libelle': 'Export',
                                        'description': 'Export',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '8cd61848-31d4-41f3-a8c8-097054109ef6',
                                'libelle': 'Opcvm.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': '02380b6c-2e95-44b4-8653-04c33ec078d5',
                                    'libelle': 'Titres.Opcvm',
                                    'description': 'Opcvm',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '707ec7bd-eb0c-418a-915f-f97e335aa1bb',
                                'libelle': 'Comptes.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': 'f20e5b8d-d256-48db-8375-c1a6dcab6875',
                                    'libelle': 'Fonds.Comptes',
                                    'description': 'Comptes',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'e237bc97-2d7c-473e-a5bb-a2dae36a4307',
                                'libelle': 'Fonds.Compartiment',
                                'description': 'Compartiment',
                                'parent': {
                                    'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                    'libelle': 'Referentiel.Fonds',
                                    'description': 'Fonds',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '6ced4355-e978-477f-a8db-9cd1ea7af901',
                                'libelle': 'General.Template_des_fichiers_de_creances',
                                'description': 'Template des fichiers de creances',
                                'parent': {
                                    'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                    'libelle': 'Referentiel.General',
                                    'description': 'General',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '8dd3ab54-88f5-45c8-8eb1-548f8a3da45b',
                                'libelle': 'Criteres_d eligibilite.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': 'd43443a0-fc86-40c5-9b4e-de07059fc8a3',
                                    'libelle': 'Fonds.Criteres_d_eligibilite',
                                    'description': 'Criteres d eligibilite',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '00288e05-40c8-42b3-9b1a-af7a9ddd40cc',
                                'libelle': 'Criteres_d_eligibilite.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': 'd43443a0-fc86-40c5-9b4e-de07059fc8a3',
                                    'libelle': 'Fonds.Criteres_d_eligibilite',
                                    'description': 'Criteres d eligibilite',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'e563e683-e930-4007-bfa5-f286e67ba7c6',
                                'libelle': 'Evenements.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': 'c56df043-3801-42e0-b449-c5975cb57527',
                                    'libelle': 'General.Evenements',
                                    'description': 'Evenements',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'ff635e40-de06-4776-9706-f9e83ea539e8',
                                'libelle': 'Gestion_d_actif.Selection_de_creances',
                                'description': 'Selection de creances',
                                'parent': {
                                    'id': 'a28463d4-088c-4a96-9f7c-def53b10d01a',
                                    'libelle': 'Gestion.Gestion_d_actif',
                                    'description': 'Gestion d actif',
                                    'parent': {
                                        'id': 'e8b3ee08-e760-41b5-9d5f-6214d2b1dd92',
                                        'libelle': 'Gestion',
                                        'description': 'Gestion',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'f7619b0b-44d4-46fe-874f-8642870dc117',
                                'libelle': 'General.Creances',
                                'description': 'Creances',
                                'parent': {
                                    'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                    'libelle': 'Referentiel.General',
                                    'description': 'General',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                'libelle': 'Investisseur',
                                'description': 'Investisseur',
                                'parent': null
                            }, {
                                'id': '6cc378cd-fc8c-4410-8282-9c552625d03b',
                                'libelle': 'Waterfall.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '5dad5a7a-c125-4221-ae83-549f825cad2a',
                                    'libelle': 'Fonds.Waterfall',
                                    'description': 'Waterfall',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                'libelle': 'Referentiel',
                                'description': 'Referentiel',
                                'parent': null
                            }, {
                                'id': '7bd18539-e434-47b1-b746-010bea164a02',
                                'libelle': 'Export.Reporting',
                                'description': 'Reporting',
                                'parent': {
                                    'id': '2488ac3b-4d5f-4084-827a-c7adf774d440',
                                    'libelle': 'Export',
                                    'description': 'Export',
                                    'parent': null
                                }
                            }, {
                                'id': '5f4e3b4f-58a9-4647-a5e1-3229593170be',
                                'libelle': 'Placement_de_tresorerie.Titre_de_creances',
                                'description': 'Titre de creances',
                                'parent': {
                                    'id': '2d311df5-dfd2-4232-a4fa-d978d4077f53',
                                    'libelle': 'Placement_de_tresorerie',
                                    'description': 'Placement de tresorerie',
                                    'parent': null
                                }
                            }, {
                                'id': 'aad93efe-1153-4607-86cd-517335f89fe7',
                                'libelle': 'Utilisateur.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': 'ec0aadd8-a0b1-4018-af41-1f284db9f8be',
                                    'libelle': 'Administration.Utilisateur',
                                    'description': 'Utilisateur',
                                    'parent': {
                                        'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                        'libelle': 'Administration',
                                        'description': 'Administration',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'b092c097-e1ff-45a4-992d-3a8e9e50017b',
                                'libelle': 'General.Jours_feries',
                                'description': 'Jours feries',
                                'parent': {
                                    'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                    'libelle': 'Referentiel.General',
                                    'description': 'General',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '2d311df5-dfd2-4232-a4fa-d978d4077f53',
                                'libelle': 'Placement_de_tresorerie',
                                'description': 'Placement de tresorerie',
                                'parent': null
                            }, {
                                'id': '2cff5eb0-72f4-464f-aa9b-ebe627fc79ff',
                                'libelle': 'Opcvm.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': '02380b6c-2e95-44b4-8653-04c33ec078d5',
                                    'libelle': 'Titres.Opcvm',
                                    'description': 'Opcvm',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '2a116b05-c151-44cb-a4d6-a698251d5b19',
                                'libelle': 'Groupe_utilisateur.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': '4ca2452e-1c8d-4a4b-a310-086799746ef5',
                                    'libelle': 'Administration.Groupe_utilisateur',
                                    'description': 'Groupe utilisateur',
                                    'parent': {
                                        'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                        'libelle': 'Administration',
                                        'description': 'Administration',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '8a178a6e-5e92-46c3-81ea-2b182adbaef0',
                                'libelle': 'Parts_residuelles.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'ecb14744-e1c7-48c7-870a-4dc0cffef664',
                                    'libelle': 'Titres.Parts_residuelles',
                                    'description': 'Parts residuelles',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'bebf8d1c-6695-416a-9e83-3450a0ec8440',
                                'libelle': 'Dat.Passer_un_ordre',
                                'description': 'Passer un ordre',
                                'parent': {
                                    'id': 'c644122f-e373-4031-a7d8-4b25eb9ef698',
                                    'libelle': 'Placement_de_tresorerie.Dat',
                                    'description': 'Dat',
                                    'parent': {
                                        'id': '2d311df5-dfd2-4232-a4fa-d978d4077f53',
                                        'libelle': 'Placement_de_tresorerie',
                                        'description': 'Placement de tresorerie',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '038c50bd-2b62-4340-ba76-4283f6f809ea',
                                'libelle': 'Titre_de_creances.Supprimer_un_placement',
                                'description': 'Supprimer un placement',
                                'parent': {
                                    'id': '5f4e3b4f-58a9-4647-a5e1-3229593170be',
                                    'libelle': 'Placement_de_tresorerie.Titre_de_creances',
                                    'description': 'Titre de creances',
                                    'parent': {
                                        'id': '2d311df5-dfd2-4232-a4fa-d978d4077f53',
                                        'libelle': 'Placement_de_tresorerie',
                                        'description': 'Placement de tresorerie',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '10da9523-33a9-45a1-bb37-50f2ec10730f',
                                'libelle': 'Opcvm.Supprimer_un_placement',
                                'description': 'Supprimer un placement',
                                'parent': {
                                    'id': '02380b6c-2e95-44b4-8653-04c33ec078d5',
                                    'libelle': 'Titres.Opcvm',
                                    'description': 'Opcvm',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'a02937af-c8af-4519-a05f-2a1dd205d636',
                                'libelle': 'Documents.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': '1183eded-998d-43dc-89b0-153330aaea60',
                                    'libelle': 'Fonds.Documents',
                                    'description': 'Documents',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'a28463d4-088c-4a96-9f7c-def53b10d01a',
                                'libelle': 'Gestion.Gestion_d_actif',
                                'description': 'Gestion d actif',
                                'parent': {
                                    'id': 'e8b3ee08-e760-41b5-9d5f-6214d2b1dd92',
                                    'libelle': 'Gestion',
                                    'description': 'Gestion',
                                    'parent': null
                                }
                            }, {
                                'id': 'e0f8c6cb-cb61-4c43-955c-478b9b2f06dd',
                                'libelle': 'Waterfall.Configurer',
                                'description': 'Configurer',
                                'parent': {
                                    'id': '5dad5a7a-c125-4221-ae83-549f825cad2a',
                                    'libelle': 'Fonds.Waterfall',
                                    'description': 'Waterfall',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '3bdfbd20-01d2-467f-a999-2f8a91b47c0f',
                                'libelle': 'Groupe_utilisateur.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '4ca2452e-1c8d-4a4b-a310-086799746ef5',
                                    'libelle': 'Administration.Groupe_utilisateur',
                                    'description': 'Groupe utilisateur',
                                    'parent': {
                                        'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                        'libelle': 'Administration',
                                        'description': 'Administration',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '1ffd53b8-4bed-48d1-8c96-9b9c42e763af',
                                'libelle': 'Investisseur.Souscription',
                                'description': 'Souscription',
                                'parent': {
                                    'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                    'libelle': 'Investisseur',
                                    'description': 'Investisseur',
                                    'parent': null
                                }
                            }, {
                                'id': 'bbeb1037-d189-4f8e-8218-8a9086b71777',
                                'libelle': 'Frais_de_fonctionnement.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': '7f082639-2a71-48e1-a8fc-e059f1ba6041',
                                    'libelle': 'Fonds.Frais_de_fonctionnement',
                                    'description': 'Frais de fonctionnement',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'ab395e0f-3b06-45ae-9fca-f73cca2490d1',
                                'libelle': 'Comptes.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'f20e5b8d-d256-48db-8375-c1a6dcab6875',
                                    'libelle': 'Fonds.Comptes',
                                    'description': 'Comptes',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '3fc85126-077c-46f4-9e8e-9cdb99767c97',
                                'libelle': 'Portefeuille_du_fonds.Balance',
                                'description': 'Balance',
                                'parent': {
                                    'id': '436f77b5-6ec1-4660-a0b6-5ba28e2d0c26',
                                    'libelle': 'Portefeuille_du_fonds',
                                    'description': 'Portefeuille du fonds',
                                    'parent': null
                                }
                            }, {
                                'id': '1d921e78-0638-4fbd-ba47-68b79d8040ff',
                                'libelle': 'Creances.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'f7619b0b-44d4-46fe-874f-8642870dc117',
                                    'libelle': 'General.Creances',
                                    'description': 'Creances',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'a0339032-f8a5-4d9f-b166-873c58ab8805',
                                'libelle': 'Export.Virement',
                                'description': 'Virement',
                                'parent': {
                                    'id': '2488ac3b-4d5f-4084-827a-c7adf774d440',
                                    'libelle': 'Export',
                                    'description': 'Export',
                                    'parent': null
                                }
                            }, {
                                'id': 'edd2cf81-8074-4890-b566-b2af46a4584e',
                                'libelle': 'Swap.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '60ddb4a4-ef5f-4f44-94cb-3c76dfac71c2',
                                    'libelle': 'General.Swaps',
                                    'description': 'Swaps',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '24a04239-483c-4d1e-a38c-815f17056e44',
                                'libelle': 'Documents.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': '1183eded-998d-43dc-89b0-153330aaea60',
                                    'libelle': 'Fonds.Documents',
                                    'description': 'Documents',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '5583a6ff-1036-4dd0-95c3-fd78bc5dec4b',
                                'libelle': 'Titre_de_creances.Passer_un_ordre',
                                'description': 'Passer un ordre',
                                'parent': {
                                    'id': '5f4e3b4f-58a9-4647-a5e1-3229593170be',
                                    'libelle': 'Placement_de_tresorerie.Titre_de_creances',
                                    'description': 'Titre de creances',
                                    'parent': {
                                        'id': '2d311df5-dfd2-4232-a4fa-d978d4077f53',
                                        'libelle': 'Placement_de_tresorerie',
                                        'description': 'Placement de tresorerie',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'e894871e-f9f1-4ec9-8a16-f208a1d067f2',
                                'libelle': 'Administration.Permission',
                                'description': 'Permission',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': '1933bd5f-453f-437d-a953-069d47f851aa',
                                'libelle': 'Creances.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': 'f7619b0b-44d4-46fe-874f-8642870dc117',
                                    'libelle': 'General.Creances',
                                    'description': 'Creances',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '18e6794e-adc9-4bc8-b7dd-d0d22c9aee85',
                                'libelle': 'Parts_residuelles.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': 'ecb14744-e1c7-48c7-870a-4dc0cffef664',
                                    'libelle': 'Titres.Parts_residuelles',
                                    'description': 'Parts residuelles',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '3d26f77c-adb6-416f-9a1d-90ee2a9d1403',
                                'libelle': 'Utilisateur.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': 'ec0aadd8-a0b1-4018-af41-1f284db9f8be',
                                    'libelle': 'Administration.Utilisateur',
                                    'description': 'Utilisateur',
                                    'parent': {
                                        'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                        'libelle': 'Administration',
                                        'description': 'Administration',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'c980f516-58bd-4d3d-b1c7-d7260a710070',
                                'libelle': 'Criteres_d_eligibilite.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'd43443a0-fc86-40c5-9b4e-de07059fc8a3',
                                    'libelle': 'Fonds.Criteres_d_eligibilite',
                                    'description': 'Criteres d eligibilite',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '9b98338c-c417-4db6-889e-c20ad9aa25e3',
                                'libelle': 'Investisseur.Balance',
                                'description': 'Balance',
                                'parent': {
                                    'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                    'libelle': 'Investisseur',
                                    'description': 'Investisseur',
                                    'parent': null
                                }
                            }, {
                                'id': 'd0dd3073-988d-4e8f-aae5-f36565493d2c',
                                'libelle': 'Creances.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': 'f7619b0b-44d4-46fe-874f-8642870dc117',
                                    'libelle': 'General.Creances',
                                    'description': 'Creances',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'fbace043-1851-4727-a470-edfc96babc60',
                                'libelle': 'Bilan_simplifie.Exporter',
                                'description': 'Exporter',
                                'parent': {
                                    'id': '5ea5b456-f072-468c-a912-93d7f9370948',
                                    'libelle': 'Comptabilite.Bilan_simplifie',
                                    'description': 'Bilan simplifie',
                                    'parent': {
                                        'id': 'b7474c5a-c302-4575-a7e8-ef7e52fdf464',
                                        'libelle': 'Comptabilite',
                                        'description': 'Comptabilite',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '2488ac3b-4d5f-4084-827a-c7adf774d440',
                                'libelle': 'Export',
                                'description': 'Export',
                                'parent': null
                            }, {
                                'id': '54c1571b-7e28-4ef3-96d4-64a346f9d715',
                                'libelle': 'Dat.Modifier_un_placement',
                                'description': 'Modifier un placement',
                                'parent': {
                                    'id': 'c644122f-e373-4031-a7d8-4b25eb9ef698',
                                    'libelle': 'Placement_de_tresorerie.Dat',
                                    'description': 'Dat',
                                    'parent': {
                                        'id': '2d311df5-dfd2-4232-a4fa-d978d4077f53',
                                        'libelle': 'Placement_de_tresorerie',
                                        'description': 'Placement de tresorerie',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '3abdeccc-96d7-4de7-a938-bda8655d579f',
                                'libelle': 'Tcn.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': '5c39aa85-a00f-47ba-a8f1-1e0b736130cd',
                                    'libelle': 'Titres.Tcn',
                                    'description': 'Tcn',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '3bcc9d04-1399-4033-b814-17ca325da689',
                                'libelle': 'General.Tranching',
                                'description': 'Tranching',
                                'parent': {
                                    'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                    'libelle': 'Referentiel.General',
                                    'description': 'General',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'e8b558b9-5739-4620-b2ea-22c5ba276e6f',
                                'libelle': 'Swap.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': '60ddb4a4-ef5f-4f44-94cb-3c76dfac71c2',
                                    'libelle': 'General.Swaps',
                                    'description': 'Swaps',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '95ef2ef1-1f99-4869-a07b-5809a09572e5',
                                'libelle': 'Reserves.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': 'eb57884e-e8da-43c8-bedb-e3bf53afc1ba',
                                    'libelle': 'General.Reserves',
                                    'description': 'Reserves',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '436f77b5-6ec1-4660-a0b6-5ba28e2d0c26',
                                'libelle': 'Portefeuille_du_fonds',
                                'description': 'Portefeuille du fonds',
                                'parent': null
                            }, {
                                'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                'libelle': 'Referentiel.Fonds',
                                'description': 'Fonds',
                                'parent': {
                                    'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                    'libelle': 'Referentiel',
                                    'description': 'Referentiel',
                                    'parent': null
                                }
                            }, {
                                'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                'libelle': 'Administration',
                                'description': 'Administration',
                                'parent': null
                            }, {
                                'id': 'c1c4ac56-cf7b-42d0-a38c-1ea03d99df68',
                                'libelle': 'Type_operation.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': 'cd2aadbc-8821-4b7a-b7c1-971398773a69',
                                    'libelle': 'General.Type_operation',
                                    'description': 'Type operation',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '823a3eb0-101d-4241-8ba4-aafcba1ae6ab',
                                'libelle': 'Emission_de_titre.Saisie_d_ordre',
                                'description': 'Saisie d ordre',
                                'parent': {
                                    'id': '64c09a45-965f-43c7-aa03-a03e5f63211c',
                                    'libelle': 'Portefeuille_du_fonds.Emission_de_titre',
                                    'description': 'Emission de titre',
                                    'parent': {
                                        'id': '436f77b5-6ec1-4660-a0b6-5ba28e2d0c26',
                                        'libelle': 'Portefeuille_du_fonds',
                                        'description': 'Portefeuille du fonds',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '02380b6c-2e95-44b4-8653-04c33ec078d5',
                                'libelle': 'Titres.Opcvm',
                                'description': 'Opcvm',
                                'parent': {
                                    'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                    'libelle': 'Referentiel.Titres',
                                    'description': 'Titres',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'a4382c29-ea51-4e01-b497-c61e2f5d98ab',
                                'libelle': 'Investisseur.Passif',
                                'description': 'Passif',
                                'parent': {
                                    'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                    'libelle': 'Investisseur',
                                    'description': 'Investisseur',
                                    'parent': null
                                }
                            }, {
                                'id': '47d5c828-6cfe-4762-a2d2-a8d1064780d0',
                                'libelle': 'Etat.Edition_de_portefeuille_parts_ou_titres',
                                'description': 'Edition de portefeuille parts ou titres',
                                'parent': {
                                    'id': 'e81367a2-fba3-49b3-ace4-be1c887b4dd5',
                                    'libelle': 'Investisseur.Etat',
                                    'description': 'Etat',
                                    'parent': {
                                        'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                        'libelle': 'Investisseur',
                                        'description': 'Investisseur',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '8308ab70-fca8-4b38-88a5-d6d2bb617173',
                                'libelle': 'Creances.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': 'f7619b0b-44d4-46fe-874f-8642870dc117',
                                    'libelle': 'General.Creances',
                                    'description': 'Creances',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '1183eded-998d-43dc-89b0-153330aaea60',
                                'libelle': 'Fonds.Documents',
                                'description': 'Documents',
                                'parent': {
                                    'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                    'libelle': 'Referentiel.Fonds',
                                    'description': 'Fonds',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '165963c1-ed63-4ca5-bc55-1b5580ffa192',
                                'libelle': 'Calendrier_de_gestion.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': '66069590-d3a6-4b7e-b05e-002e84dbe0a6',
                                    'libelle': 'Fonds.Calendrier_de_gestion',
                                    'description': 'Calendrier de gestion',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '518c5029-9893-444d-8949-a8b5a9a65fab',
                                'libelle': 'Gestion_des_investisseurs.Consultation',
                                'description': 'Consultation',
                                'parent': {
                                    'id': 'b3b40069-9c43-46f4-8553-f36a72df6c9d',
                                    'libelle': 'Investisseur.Gestion_des_comptes_investisseurs',
                                    'description': 'Gestion des comptes investisseurs',
                                    'parent': {
                                        'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                        'libelle': 'Investisseur',
                                        'description': 'Investisseur',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '7c17b6ff-363e-4ca3-84e6-1f89f37adf6f',
                                'libelle': 'General.Etablissements_bancaires',
                                'description': 'Etablissements bancaires',
                                'parent': {
                                    'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                    'libelle': 'Referentiel.General',
                                    'description': 'General',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '66069590-d3a6-4b7e-b05e-002e84dbe0a6',
                                'libelle': 'Fonds.Calendrier_de_gestion',
                                'description': 'Calendrier de gestion',
                                'parent': {
                                    'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                    'libelle': 'Referentiel.Fonds',
                                    'description': 'Fonds',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '5c39aa85-a00f-47ba-a8f1-1e0b736130cd',
                                'libelle': 'Titres.Tcn',
                                'description': 'Tcn',
                                'parent': {
                                    'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                    'libelle': 'Referentiel.Titres',
                                    'description': 'Titres',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'a503c966-ec21-4a89-9703-bada3dfb37cf',
                                'libelle': 'Audit',
                                'description': 'Audit',
                                'parent': null
                            }, {
                                'id': '319454b2-f8e0-4460-857a-01cc32fdf6dd',
                                'libelle': 'Opcvm.Passer_un_ordre',
                                'description': 'Passer un ordre',
                                'parent': {
                                    'id': '02380b6c-2e95-44b4-8653-04c33ec078d5',
                                    'libelle': 'Titres.Opcvm',
                                    'description': 'Opcvm',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '719efbb9-a6d3-47b5-b772-6ef7760c7a11',
                                'libelle': 'Export.Management_Report',
                                'description': 'Management Report',
                                'parent': {
                                    'id': '2488ac3b-4d5f-4084-827a-c7adf774d440',
                                    'libelle': 'Export',
                                    'description': 'Export',
                                    'parent': null
                                }
                            }, {
                                'id': '79cb25d7-5c29-4790-bbd2-11726ae93e46',
                                'libelle': 'Portefeuille_passif.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '983ad26b-b6a8-4a8b-90af-612a0ef16849',
                                    'libelle': 'Portefeuille_du_fonds.Portefeuille_passif',
                                    'description': 'Portefeuille passif',
                                    'parent': {
                                        'id': '436f77b5-6ec1-4660-a0b6-5ba28e2d0c26',
                                        'libelle': 'Portefeuille_du_fonds',
                                        'description': 'Portefeuille du fonds',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '7ea38474-4756-42ae-8d5c-4f74db2ebb64',
                                'libelle': 'Rating.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '44a030e8-4090-420a-858b-988672179248',
                                    'libelle': 'General.Rating',
                                    'description': 'Rating',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'e8b3ee08-e760-41b5-9d5f-6214d2b1dd92',
                                'libelle': 'Gestion',
                                'description': 'Gestion',
                                'parent': null
                            }, {
                                'id': '4aaeaf5d-257a-44c4-961b-6ab825cc4aa2',
                                'libelle': 'Virement.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'a0339032-f8a5-4d9f-b166-873c58ab8805',
                                    'libelle': 'Export.Virement',
                                    'description': 'Virement',
                                    'parent': {
                                        'id': '2488ac3b-4d5f-4084-827a-c7adf774d440',
                                        'libelle': 'Export',
                                        'description': 'Export',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'f20e5b8d-d256-48db-8375-c1a6dcab6875',
                                'libelle': 'Fonds.Comptes',
                                'description': 'Comptes',
                                'parent': {
                                    'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                    'libelle': 'Referentiel.Fonds',
                                    'description': 'Fonds',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '7646e496-5adf-4265-9030-022a1f91d20c',
                                'libelle': 'Documents.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '1183eded-998d-43dc-89b0-153330aaea60',
                                    'libelle': 'Fonds.Documents',
                                    'description': 'Documents',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '7f082639-2a71-48e1-a8fc-e059f1ba6041',
                                'libelle': 'Fonds.Frais_de_fonctionnement',
                                'description': 'Frais de fonctionnement',
                                'parent': {
                                    'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                    'libelle': 'Referentiel.Fonds',
                                    'description': 'Fonds',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '58749a14-bb44-4b1d-8e8f-61c90ca54bd4',
                                'libelle': 'Gestion.Gestion_du_passif',
                                'description': 'Gestion du passif',
                                'parent': {
                                    'id': 'e8b3ee08-e760-41b5-9d5f-6214d2b1dd92',
                                    'libelle': 'Gestion',
                                    'description': 'Gestion',
                                    'parent': null
                                }
                            }, {
                                'id': '72d43697-69e7-4e9d-8a5a-af6c4b4fcceb',
                                'libelle': 'Etude_des_comptes.Desactivation',
                                'description': 'Desactivation',
                                'parent': {
                                    'id': '0927744e-5548-48e7-a847-733985dcbd20',
                                    'libelle': 'Investisseur.Etude_des_comptes',
                                    'description': 'Etude des comptes',
                                    'parent': {
                                        'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                        'libelle': 'Investisseur',
                                        'description': 'Investisseur',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '84cb3283-8741-461a-83e9-7988fb4461c7',
                                'libelle': 'Tcn.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': '5c39aa85-a00f-47ba-a8f1-1e0b736130cd',
                                    'libelle': 'Titres.Tcn',
                                    'description': 'Tcn',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '824b3109-aa83-4f1c-8559-af81672863dc',
                                'libelle': 'Calendrier_de_gestion.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '66069590-d3a6-4b7e-b05e-002e84dbe0a6',
                                    'libelle': 'Fonds.Calendrier_de_gestion',
                                    'description': 'Calendrier de gestion',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '35f9d214-c8e7-42e5-90f4-0502fda0995b',
                                'libelle': 'General.Statistiques',
                                'description': 'Statistiques',
                                'parent': {
                                    'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                    'libelle': 'Referentiel.General',
                                    'description': 'General',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'a337ce8d-3158-4a91-8861-00a94ce38a3a',
                                'libelle': 'Placement_de_tresorerie.Opcvm',
                                'description': 'Opcvm',
                                'parent': {
                                    'id': '2d311df5-dfd2-4232-a4fa-d978d4077f53',
                                    'libelle': 'Placement_de_tresorerie',
                                    'description': 'Placement de tresorerie',
                                    'parent': null
                                }
                            }, {
                                'id': 'cc99f3e8-0c82-40df-b1ee-fa301f1df6cb',
                                'libelle': 'General.Fichiers_de_creances',
                                'description': 'Fichiers de creances',
                                'parent': {
                                    'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                    'libelle': 'Referentiel.General',
                                    'description': 'General',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'c644122f-e373-4031-a7d8-4b25eb9ef698',
                                'libelle': 'Placement_de_tresorerie.Dat',
                                'description': 'Dat',
                                'parent': {
                                    'id': '2d311df5-dfd2-4232-a4fa-d978d4077f53',
                                    'libelle': 'Placement_de_tresorerie',
                                    'description': 'Placement de tresorerie',
                                    'parent': null
                                }
                            }, {
                                'id': 'ec0aadd8-a0b1-4018-af41-1f284db9f8be',
                                'libelle': 'Administration.Utilisateur',
                                'description': 'Utilisateur',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': 'a6a29c14-dc2d-46a3-9aaa-73d50a2679aa',
                                'libelle': 'Tcn.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': '5c39aa85-a00f-47ba-a8f1-1e0b736130cd',
                                    'libelle': 'Titres.Tcn',
                                    'description': 'Tcn',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '6c1bebe6-ffc8-43dc-b900-311df0717150',
                                'libelle': 'Type_operation.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': 'cd2aadbc-8821-4b7a-b7c1-971398773a69',
                                    'libelle': 'General.Type_operation',
                                    'description': 'Type operation',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '32b73fe8-21f9-4ee6-910d-449595eccbae',
                                'libelle': 'Tcn.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '5c39aa85-a00f-47ba-a8f1-1e0b736130cd',
                                    'libelle': 'Titres.Tcn',
                                    'description': 'Tcn',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'ecb14744-e1c7-48c7-870a-4dc0cffef664',
                                'libelle': 'Titres.Parts_residuelles',
                                'description': 'Parts residuelles',
                                'parent': {
                                    'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                    'libelle': 'Referentiel.Titres',
                                    'description': 'Titres',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '8d5d0e6f-b3a0-4ded-a3dd-d6b5efb47f50',
                                'libelle': 'Jours_feries.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': 'b092c097-e1ff-45a4-992d-3a8e9e50017b',
                                    'libelle': 'General.Jours_feries',
                                    'description': 'Jours feries',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'f7eabf55-d795-4149-9b4a-658f64a1c5c4',
                                'libelle': 'Permission.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'e894871e-f9f1-4ec9-8a16-f208a1d067f2',
                                    'libelle': 'Administration.Permission',
                                    'description': 'Permission',
                                    'parent': {
                                        'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                        'libelle': 'Administration',
                                        'description': 'Administration',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'fd668ac1-3792-48e2-8015-5c2a761c812a',
                                'libelle': 'Evenements.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': 'c56df043-3801-42e0-b449-c5975cb57527',
                                    'libelle': 'General.Evenements',
                                    'description': 'Evenements',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'd83a1130-70af-4aac-b607-18c5cbbf454c',
                                'libelle': 'Calendrier_de_gestion.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': '66069590-d3a6-4b7e-b05e-002e84dbe0a6',
                                    'libelle': 'Fonds.Calendrier_de_gestion',
                                    'description': 'Calendrier de gestion',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'e27731bd-4b0f-4420-b750-fde2db4440cb',
                                'libelle': 'Titre_de_creances.Saisir_un_placement',
                                'description': 'Saisir un placement',
                                'parent': {
                                    'id': '5f4e3b4f-58a9-4647-a5e1-3229593170be',
                                    'libelle': 'Placement_de_tresorerie.Titre_de_creances',
                                    'description': 'Titre de creances',
                                    'parent': {
                                        'id': '2d311df5-dfd2-4232-a4fa-d978d4077f53',
                                        'libelle': 'Placement_de_tresorerie',
                                        'description': 'Placement de tresorerie',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '47d12e3a-5791-4ba8-9e9d-243063b33942',
                                'libelle': 'Calcul.Nouveau_calcul',
                                'description': 'Nouveau calcul',
                                'parent': {
                                    'id': '7708901d-ecbc-4166-ae4a-e21ea5a982e3',
                                    'libelle': 'Gestion.Calcul',
                                    'description': 'Calcul',
                                    'parent': {
                                        'id': 'e8b3ee08-e760-41b5-9d5f-6214d2b1dd92',
                                        'libelle': 'Gestion',
                                        'description': 'Gestion',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '6de1a84d-5691-4e5b-9c8f-fd2a6930c91c',
                                'libelle': 'Type_operation.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'cd2aadbc-8821-4b7a-b7c1-971398773a69',
                                    'libelle': 'General.Type_operation',
                                    'description': 'Type operation',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '9ea9453c-48fb-4f29-a576-4d354073c280',
                                'libelle': 'Template_des_fichiers_de_creances.Configurer',
                                'description': 'Configurer',
                                'parent': {
                                    'id': '6ced4355-e978-477f-a8db-9cd1ea7af901',
                                    'libelle': 'General.Template_des_fichiers_de_creances',
                                    'description': 'Template des fichiers de creances',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '8adb6c7e-611e-42d8-9b88-b08a37bf931e',
                                'libelle': 'Rating.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': '44a030e8-4090-420a-858b-988672179248',
                                    'libelle': 'General.Rating',
                                    'description': 'Rating',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'b1df3979-6891-412c-a63d-d3850345720c',
                                'libelle': 'Gestion_des_logs_de_validation.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'c39c9a5c-e953-41da-a8e6-7b114e1a5816',
                                    'libelle': 'Audit.Gestion_des_logs_de_validation',
                                    'description': 'Gestion des logs de validation',
                                    'parent': {
                                        'id': 'a503c966-ec21-4a89-9703-bada3dfb37cf',
                                        'libelle': 'Audit',
                                        'description': 'Audit',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '5203a49f-0793-4347-b93b-a970d42cc5b4',
                                'libelle': 'Evenements.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'c56df043-3801-42e0-b449-c5975cb57527',
                                    'libelle': 'General.Evenements',
                                    'description': 'Evenements',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '034bfdf3-648d-4b9f-94fd-5e628f91abd2',
                                'libelle': 'Emission_de_titre.Modifier_un_ordre',
                                'description': 'Modifier un ordre',
                                'parent': {
                                    'id': '64c09a45-965f-43c7-aa03-a03e5f63211c',
                                    'libelle': 'Portefeuille_du_fonds.Emission_de_titre',
                                    'description': 'Emission de titre',
                                    'parent': {
                                        'id': '436f77b5-6ec1-4660-a0b6-5ba28e2d0c26',
                                        'libelle': 'Portefeuille_du_fonds',
                                        'description': 'Portefeuille du fonds',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '04ffbd05-f1d3-41d7-852e-c6899eec6a6d',
                                'libelle': 'Calendrier_de_gestion.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': '66069590-d3a6-4b7e-b05e-002e84dbe0a6',
                                    'libelle': 'Fonds.Calendrier_de_gestion',
                                    'description': 'Calendrier de gestion',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '60ddb4a4-ef5f-4f44-94cb-3c76dfac71c2',
                                'libelle': 'General.Swaps',
                                'description': 'Swaps',
                                'parent': {
                                    'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                    'libelle': 'Referentiel.General',
                                    'description': 'General',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'c488993c-25f4-4b53-b20a-b6a6d8ca40d7',
                                'libelle': 'Swap.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': '60ddb4a4-ef5f-4f44-94cb-3c76dfac71c2',
                                    'libelle': 'General.Swaps',
                                    'description': 'Swaps',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '10c3485d-013c-4827-b7f7-d2cb4fca7400',
                                'libelle': 'Dat.Supprimer_un_placement',
                                'description': 'Supprimer un placement',
                                'parent': {
                                    'id': 'c644122f-e373-4031-a7d8-4b25eb9ef698',
                                    'libelle': 'Placement_de_tresorerie.Dat',
                                    'description': 'Dat',
                                    'parent': {
                                        'id': '2d311df5-dfd2-4232-a4fa-d978d4077f53',
                                        'libelle': 'Placement_de_tresorerie',
                                        'description': 'Placement de tresorerie',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '3d3db1f6-fb35-4646-9c80-4fe0bc723505',
                                'libelle': 'Controle_interne',
                                'description': 'Controle interne',
                                'parent': null
                            }, {
                                'id': '44a030e8-4090-420a-858b-988672179248',
                                'libelle': 'General.Rating',
                                'description': 'Rating',
                                'parent': {
                                    'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                    'libelle': 'Referentiel.General',
                                    'description': 'General',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '7921d002-0e60-40fa-bb79-45e330ef4ebc',
                                'libelle': 'Administration.Gestion_des_comptes_utilisateurs',
                                'description': 'Gestion des comptes utilisateurs',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': 'd70b8308-c941-4b53-b6d8-0f8543b59694',
                                'libelle': 'Rating.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': '44a030e8-4090-420a-858b-988672179248',
                                    'libelle': 'General.Rating',
                                    'description': 'Rating',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '3f563cfa-ca53-4e8e-ae20-4c3e57f37369',
                                'libelle': 'Parts_residuelles.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': 'ecb14744-e1c7-48c7-870a-4dc0cffef664',
                                    'libelle': 'Titres.Parts_residuelles',
                                    'description': 'Parts residuelles',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'b5893ba2-fb10-43d3-bd2f-cd9957ff7954',
                                'libelle': 'Gestion_des_investisseurs.Creation',
                                'description': 'Creation',
                                'parent': {
                                    'id': 'b3b40069-9c43-46f4-8553-f36a72df6c9d',
                                    'libelle': 'Investisseur.Gestion_des_comptes_investisseurs',
                                    'description': 'Gestion des comptes investisseurs',
                                    'parent': {
                                        'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                        'libelle': 'Investisseur',
                                        'description': 'Investisseur',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'eb925121-b643-407e-99ec-8eafb32b32a7',
                                'libelle': 'Gestion_des_logs_de_validation.Exporter',
                                'description': 'Exporter',
                                'parent': {
                                    'id': 'c39c9a5c-e953-41da-a8e6-7b114e1a5816',
                                    'libelle': 'Audit.Gestion_des_logs_de_validation',
                                    'description': 'Gestion des logs de validation',
                                    'parent': {
                                        'id': 'a503c966-ec21-4a89-9703-bada3dfb37cf',
                                        'libelle': 'Audit',
                                        'description': 'Audit',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '8f1616c7-9635-4adc-ae36-15870036b934',
                                'libelle': 'Documents.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': '1183eded-998d-43dc-89b0-153330aaea60',
                                    'libelle': 'Fonds.Documents',
                                    'description': 'Documents',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '983ad26b-b6a8-4a8b-90af-612a0ef16849',
                                'libelle': 'Portefeuille_du_fonds.Portefeuille_passif',
                                'description': 'Portefeuille passif',
                                'parent': {
                                    'id': '436f77b5-6ec1-4660-a0b6-5ba28e2d0c26',
                                    'libelle': 'Portefeuille_du_fonds',
                                    'description': 'Portefeuille du fonds',
                                    'parent': null
                                }
                            }, {
                                'id': 'ca66fee8-1974-4c56-9187-538af9fb8b73',
                                'libelle': 'Investisseur.Actif',
                                'description': 'Actif',
                                'parent': {
                                    'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                    'libelle': 'Investisseur',
                                    'description': 'Investisseur',
                                    'parent': null
                                }
                            }, {
                                'id': 'e81367a2-fba3-49b3-ace4-be1c887b4dd5',
                                'libelle': 'Investisseur.Etat',
                                'description': 'Etat',
                                'parent': {
                                    'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                    'libelle': 'Investisseur',
                                    'description': 'Investisseur',
                                    'parent': null
                                }
                            }, {
                                'id': '127875f0-4907-42f5-b2aa-8a9848f6dbe6',
                                'libelle': 'Etude_des_comptes.Rejet',
                                'description': 'Rejet',
                                'parent': {
                                    'id': '0927744e-5548-48e7-a847-733985dcbd20',
                                    'libelle': 'Investisseur.Etude_des_comptes',
                                    'description': 'Etude des comptes',
                                    'parent': {
                                        'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                        'libelle': 'Investisseur',
                                        'description': 'Investisseur',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '9f6bef71-63df-4816-9079-96fe07137b59',
                                'libelle': 'Controle_interne.Controle',
                                'description': 'Controle',
                                'parent': {
                                    'id': '3d3db1f6-fb35-4646-9c80-4fe0bc723505',
                                    'libelle': 'Controle_interne',
                                    'description': 'Controle interne',
                                    'parent': null
                                }
                            }, {
                                'id': '1b763271-59a4-43d9-abdc-c618457d09a3',
                                'libelle': 'Reporting.Generer',
                                'description': 'Generer',
                                'parent': {
                                    'id': '7bd18539-e434-47b1-b746-010bea164a02',
                                    'libelle': 'Export.Reporting',
                                    'description': 'Reporting',
                                    'parent': {
                                        'id': '2488ac3b-4d5f-4084-827a-c7adf774d440',
                                        'libelle': 'Export',
                                        'description': 'Export',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '1b4e3f1f-7b11-430a-b7dc-6e88974ff565',
                                'libelle': 'Fonds.Garanties',
                                'description': 'Garanties',
                                'parent': {
                                    'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                    'libelle': 'Referentiel.Fonds',
                                    'description': 'Fonds',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '332fe2f5-4d5d-47ae-8e5f-3594dcdf936b',
                                'libelle': 'Administration.Gestion_des_habilitations',
                                'description': 'Gestion des habilitations',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': 'd43443a0-fc86-40c5-9b4e-de07059fc8a3',
                                'libelle': 'Fonds.Criteres_d_eligibilite',
                                'description': 'Criteres d eligibilite',
                                'parent': {
                                    'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                    'libelle': 'Referentiel.Fonds',
                                    'description': 'Fonds',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '0927744e-5548-48e7-a847-733985dcbd20',
                                'libelle': 'Investisseur.Etude_des_comptes',
                                'description': 'Etude des comptes',
                                'parent': {
                                    'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                    'libelle': 'Investisseur',
                                    'description': 'Investisseur',
                                    'parent': null
                                }
                            }, {
                                'id': 'a671c9c5-127f-443f-979c-d0ad6a5cad04',
                                'libelle': 'Criteres_d_eligibilite.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': 'd43443a0-fc86-40c5-9b4e-de07059fc8a3',
                                    'libelle': 'Fonds.Criteres_d_eligibilite',
                                    'description': 'Criteres d eligibilite',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '85f3584b-2861-4e9e-bcd6-578463e287b0',
                                'libelle': 'Gestion_d_actif.Pool_des_creances',
                                'description': 'Pool des creances',
                                'parent': {
                                    'id': 'a28463d4-088c-4a96-9f7c-def53b10d01a',
                                    'libelle': 'Gestion.Gestion_d_actif',
                                    'description': 'Gestion d actif',
                                    'parent': {
                                        'id': 'e8b3ee08-e760-41b5-9d5f-6214d2b1dd92',
                                        'libelle': 'Gestion',
                                        'description': 'Gestion',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '4aab1acb-3138-46d5-8eb7-6825ae803d2a',
                                'libelle': 'Portefeuille_actif.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '341bed53-7215-4142-9162-fee635f0ae91',
                                    'libelle': 'Portefeuille_du_fonds.Portefeuille_actif',
                                    'description': 'Portefeuille actif',
                                    'parent': {
                                        'id': '436f77b5-6ec1-4660-a0b6-5ba28e2d0c26',
                                        'libelle': 'Portefeuille_du_fonds',
                                        'description': 'Portefeuille du fonds',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '5ea5b456-f072-468c-a912-93d7f9370948',
                                'libelle': 'Comptabilite.Bilan_simplifie',
                                'description': 'Bilan simplifie',
                                'parent': {
                                    'id': 'b7474c5a-c302-4575-a7e8-ef7e52fdf464',
                                    'libelle': 'Comptabilite',
                                    'description': 'Comptabilite',
                                    'parent': null
                                }
                            }, {
                                'id': 'ac39f715-af40-4195-a930-986c418764b5',
                                'libelle': 'Comptabilite.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '5920fd2a-dd1a-4451-9df6-edc7f4085f70',
                                    'libelle': 'Export.Comptabilite',
                                    'description': 'Comptabilite',
                                    'parent': {
                                        'id': '2488ac3b-4d5f-4084-827a-c7adf774d440',
                                        'libelle': 'Export',
                                        'description': 'Export',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'eb57884e-e8da-43c8-bedb-e3bf53afc1ba',
                                'libelle': 'General.Reserves',
                                'description': 'Reserves',
                                'parent': {
                                    'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                    'libelle': 'Referentiel.General',
                                    'description': 'General',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '6107583a-76f5-4c0c-9689-c2101e47c0f5',
                                'libelle': 'Fonds.General',
                                'description': 'General',
                                'parent': {
                                    'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                    'libelle': 'Referentiel.Fonds',
                                    'description': 'Fonds',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '04509c2f-3f4c-4b8a-b8f8-c79c87c2a5e9',
                                'libelle': 'Opcvm.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '02380b6c-2e95-44b4-8653-04c33ec078d5',
                                    'libelle': 'Titres.Opcvm',
                                    'description': 'Opcvm',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'a5b35545-9743-47bb-b8de-aa0c6e2c1161',
                                'libelle': 'Waterfall.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': '5dad5a7a-c125-4221-ae83-549f825cad2a',
                                    'libelle': 'Fonds.Waterfall',
                                    'description': 'Waterfall',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'cf534f71-81e1-48dd-8cad-1a8ec45870da',
                                'libelle': 'Emission_de_titre.Consulter_titre',
                                'description': 'Consulter titre',
                                'parent': {
                                    'id': '64c09a45-965f-43c7-aa03-a03e5f63211c',
                                    'libelle': 'Portefeuille_du_fonds.Emission_de_titre',
                                    'description': 'Emission de titre',
                                    'parent': {
                                        'id': '436f77b5-6ec1-4660-a0b6-5ba28e2d0c26',
                                        'libelle': 'Portefeuille_du_fonds',
                                        'description': 'Portefeuille du fonds',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '71550878-2f6f-4165-a5ce-cfeafffe05c4',
                                'libelle': 'Gestion_des_logs_de_consultation.Exporter',
                                'description': 'Exporter',
                                'parent': {
                                    'id': 'cf9963d6-bc78-449a-a453-6f4daba0eb92',
                                    'libelle': 'Audit.Gestion_des_logs_de_consultation',
                                    'description': 'Gestion des logs de consultation',
                                    'parent': {
                                        'id': 'a503c966-ec21-4a89-9703-bada3dfb37cf',
                                        'libelle': 'Audit',
                                        'description': 'Audit',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'aac1d4ba-0469-40c1-afa4-1ea84e553ea0',
                                'libelle': 'General.Triggers',
                                'description': 'Triggers',
                                'parent': {
                                    'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                    'libelle': 'Referentiel.General',
                                    'description': 'General',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'c950e820-795e-49f3-ad50-f8caf3acb93e',
                                'libelle': 'Reserves.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': 'eb57884e-e8da-43c8-bedb-e3bf53afc1ba',
                                    'libelle': 'General.Reserves',
                                    'description': 'Reserves',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                'libelle': 'Referentiel.Titres',
                                'description': 'Titres',
                                'parent': {
                                    'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                    'libelle': 'Referentiel',
                                    'description': 'Referentiel',
                                    'parent': null
                                }
                            }, {
                                'id': 'de2c7d05-2817-42d1-a9a6-33f73d660a33',
                                'libelle': 'Etat.Edition_de_releve_des_mouvements_des_comptes',
                                'description': 'Edition de releve des mouvements des comptes',
                                'parent': {
                                    'id': 'e81367a2-fba3-49b3-ace4-be1c887b4dd5',
                                    'libelle': 'Investisseur.Etat',
                                    'description': 'Etat',
                                    'parent': {
                                        'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                        'libelle': 'Investisseur',
                                        'description': 'Investisseur',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '100e1e88-0f7e-48a5-9a66-4e466e662107',
                                'libelle': 'Reserves.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': 'eb57884e-e8da-43c8-bedb-e3bf53afc1ba',
                                    'libelle': 'General.Reserves',
                                    'description': 'Reserves',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '2bff4520-c866-40d1-910f-873f90f1dd90',
                                'libelle': 'Opcvm.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': '02380b6c-2e95-44b4-8653-04c33ec078d5',
                                    'libelle': 'Titres.Opcvm',
                                    'description': 'Opcvm',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'c39c9a5c-e953-41da-a8e6-7b114e1a5816',
                                'libelle': 'Audit.Gestion_des_logs_de_validation',
                                'description': 'Gestion des logs de validation',
                                'parent': {
                                    'id': 'a503c966-ec21-4a89-9703-bada3dfb37cf',
                                    'libelle': 'Audit',
                                    'description': 'Audit',
                                    'parent': null
                                }
                            }, {
                                'id': 'e1ca5c83-00c1-4a03-a458-deb0414d6aa6',
                                'libelle': 'Virement.Generer',
                                'description': 'Generer',
                                'parent': {
                                    'id': 'a0339032-f8a5-4d9f-b166-873c58ab8805',
                                    'libelle': 'Export.Virement',
                                    'description': 'Virement',
                                    'parent': {
                                        'id': '2488ac3b-4d5f-4084-827a-c7adf774d440',
                                        'libelle': 'Export',
                                        'description': 'Export',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '0dee5870-3f66-40d8-87e8-6ab6362bc20c',
                                'libelle': 'Swap.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': '60ddb4a4-ef5f-4f44-94cb-3c76dfac71c2',
                                    'libelle': 'General.Swaps',
                                    'description': 'Swaps',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'ffab43c3-1308-45c9-af0d-55d7277478ed',
                                'libelle': 'Parts_residuelles.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': 'ecb14744-e1c7-48c7-870a-4dc0cffef664',
                                    'libelle': 'Titres.Parts_residuelles',
                                    'description': 'Parts residuelles',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'd9fc2774-e7fd-45bf-b516-2ecb54debfca',
                                'libelle': 'Comptes.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': 'f20e5b8d-d256-48db-8375-c1a6dcab6875',
                                    'libelle': 'Fonds.Comptes',
                                    'description': 'Comptes',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '7fc0fa1e-9f81-457f-bb37-77a283e1bd98',
                                'libelle': 'Type_operation.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': 'cd2aadbc-8821-4b7a-b7c1-971398773a69',
                                    'libelle': 'General.Type_operation',
                                    'description': 'Type operation',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '989b7cdb-b81f-4cb1-99d1-cbdef6d16e50',
                                'libelle': 'Opcvm.Modifier_un_placement',
                                'description': 'Modifier un placement',
                                'parent': {
                                    'id': '02380b6c-2e95-44b4-8653-04c33ec078d5',
                                    'libelle': 'Titres.Opcvm',
                                    'description': 'Opcvm',
                                    'parent': {
                                        'id': '7ea40415-cc86-4a26-a7c9-703803f45ec6',
                                        'libelle': 'Referentiel.Titres',
                                        'description': 'Titres',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '49bfa5d6-caa1-49d4-8544-e1a455fa1dca',
                                'libelle': 'Investisseur.Gestion_des_investisseurs',
                                'description': 'Gestion des investisseurs',
                                'parent': {
                                    'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                    'libelle': 'Investisseur',
                                    'description': 'Investisseur',
                                    'parent': null
                                }
                            }, {
                                'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                'libelle': 'Referentiel.General',
                                'description': 'General',
                                'parent': {
                                    'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                    'libelle': 'Referentiel',
                                    'description': 'Referentiel',
                                    'parent': null
                                }
                            }, {
                                'id': '7e35ec20-bcb1-4320-9a5b-81d9cb4a22ce',
                                'libelle': 'Comptabilite.Generer',
                                'description': 'Generer',
                                'parent': {
                                    'id': '5920fd2a-dd1a-4451-9df6-edc7f4085f70',
                                    'libelle': 'Export.Comptabilite',
                                    'description': 'Comptabilite',
                                    'parent': {
                                        'id': '2488ac3b-4d5f-4084-827a-c7adf774d440',
                                        'libelle': 'Export',
                                        'description': 'Export',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'cd2aadbc-8821-4b7a-b7c1-971398773a69',
                                'libelle': 'General.Type_operation',
                                'description': 'Type operation',
                                'parent': {
                                    'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                    'libelle': 'Referentiel.General',
                                    'description': 'General',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'b202f57a-6cdb-42db-aab0-3fb8deeffb67',
                                'libelle': 'Tableau_de_bord',
                                'description': 'Tableau de bord',
                                'parent': null
                            }, {
                                'id': '50a2ac08-37c6-4f6f-a692-260fb22d2289',
                                'libelle': 'Template_des_fichiers_de_creances.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': '6ced4355-e978-477f-a8db-9cd1ea7af901',
                                    'libelle': 'General.Template_des_fichiers_de_creances',
                                    'description': 'Template des fichiers de creances',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '0748a59b-c19d-4ed6-b954-edd84d94fa25',
                                'libelle': 'Gestion_des_investisseurs.Modification',
                                'description': 'Modification',
                                'parent': {
                                    'id': 'b3b40069-9c43-46f4-8553-f36a72df6c9d',
                                    'libelle': 'Investisseur.Gestion_des_comptes_investisseurs',
                                    'description': 'Gestion des comptes investisseurs',
                                    'parent': {
                                        'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                        'libelle': 'Investisseur',
                                        'description': 'Investisseur',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '32423baa-325c-4a81-9336-00e042ce6aac',
                                'libelle': 'Groupe_utilisateur.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': '4ca2452e-1c8d-4a4b-a310-086799746ef5',
                                    'libelle': 'Administration.Groupe_utilisateur',
                                    'description': 'Groupe utilisateur',
                                    'parent': {
                                        'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                        'libelle': 'Administration',
                                        'description': 'Administration',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'c9ac194d-4ef4-46f0-bac5-4a40cdf209e6',
                                'libelle': 'Rating.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': '44a030e8-4090-420a-858b-988672179248',
                                    'libelle': 'General.Rating',
                                    'description': 'Rating',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '606c2f42-b841-4572-9a85-352281fb887e',
                                'libelle': 'Etude_des_comptes.Activation',
                                'description': 'Activation',
                                'parent': {
                                    'id': '0927744e-5548-48e7-a847-733985dcbd20',
                                    'libelle': 'Investisseur.Etude_des_comptes',
                                    'description': 'Etude des comptes',
                                    'parent': {
                                        'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                        'libelle': 'Investisseur',
                                        'description': 'Investisseur',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '5920fd2a-dd1a-4451-9df6-edc7f4085f70',
                                'libelle': 'Export.Comptabilite',
                                'description': 'Comptabilite',
                                'parent': {
                                    'id': '2488ac3b-4d5f-4084-827a-c7adf774d440',
                                    'libelle': 'Export',
                                    'description': 'Export',
                                    'parent': null
                                }
                            }, {
                                'id': '4ca2452e-1c8d-4a4b-a310-086799746ef5',
                                'libelle': 'Administration.Groupe_utilisateur',
                                'description': 'Groupe utilisateur',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': '89e83c53-5b1a-4466-878f-f98a918105d5',
                                'libelle': 'Evenements.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': 'c56df043-3801-42e0-b449-c5975cb57527',
                                    'libelle': 'General.Evenements',
                                    'description': 'Evenements',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'ad50e225-3843-4655-9886-e74d4a0e55fc',
                                'libelle': 'Frais_de_fonctionnement.Modifier',
                                'description': 'Modifier',
                                'parent': {
                                    'id': '7f082639-2a71-48e1-a8fc-e059f1ba6041',
                                    'libelle': 'Fonds.Frais_de_fonctionnement',
                                    'description': 'Frais de fonctionnement',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '54808de1-d5f6-4911-8e47-535587a58c99',
                                'libelle': 'Comptes.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': 'f20e5b8d-d256-48db-8375-c1a6dcab6875',
                                    'libelle': 'Fonds.Comptes',
                                    'description': 'Comptes',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '5c9710ea-3072-4149-a19a-1ed447707209',
                                'libelle': 'Jours_feries.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': 'b092c097-e1ff-45a4-992d-3a8e9e50017b',
                                    'libelle': 'General.Jours_feries',
                                    'description': 'Jours feries',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'b3b40069-9c43-46f4-8553-f36a72df6c9d',
                                'libelle': 'Investisseur.Gestion_des_comptes_investisseurs',
                                'description': 'Gestion des comptes investisseurs',
                                'parent': {
                                    'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                    'libelle': 'Investisseur',
                                    'description': 'Investisseur',
                                    'parent': null
                                }
                            }, {
                                'id': 'b30d5be2-5d31-4e1f-9336-202c4e46f18c',
                                'libelle': 'Placement_de_tresorerie.Tresorerie_consolidee',
                                'description': 'Tresorerie consolidee',
                                'parent': {
                                    'id': '2d311df5-dfd2-4232-a4fa-d978d4077f53',
                                    'libelle': 'Placement_de_tresorerie',
                                    'description': 'Placement de tresorerie',
                                    'parent': null
                                }
                            }, {
                                'id': '86cb01cc-1979-429e-b41c-ceda4396b8c4',
                                'libelle': 'Groupe_utilisateur.Ajouter',
                                'description': 'Ajouter',
                                'parent': {
                                    'id': '4ca2452e-1c8d-4a4b-a310-086799746ef5',
                                    'libelle': 'Administration.Groupe_utilisateur',
                                    'description': 'Groupe utilisateur',
                                    'parent': {
                                        'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                        'libelle': 'Administration',
                                        'description': 'Administration',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'a1a1bd58-918c-4e9c-8a21-036e7ed15eec',
                                'libelle': 'Dat.Saisir_un_placement',
                                'description': 'Saisir un placement',
                                'parent': {
                                    'id': 'c644122f-e373-4031-a7d8-4b25eb9ef698',
                                    'libelle': 'Placement_de_tresorerie.Dat',
                                    'description': 'Dat',
                                    'parent': {
                                        'id': '2d311df5-dfd2-4232-a4fa-d978d4077f53',
                                        'libelle': 'Placement_de_tresorerie',
                                        'description': 'Placement de tresorerie',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': 'a2fcc5c3-d175-46f2-9697-9b836e7129ed',
                                'libelle': 'Waterfall.Supprimer',
                                'description': 'Supprimer',
                                'parent': {
                                    'id': '5dad5a7a-c125-4221-ae83-549f825cad2a',
                                    'libelle': 'Fonds.Waterfall',
                                    'description': 'Waterfall',
                                    'parent': {
                                        'id': '949d58ac-e7e1-455f-9869-e381bb7acf44',
                                        'libelle': 'Referentiel.Fonds',
                                        'description': 'Fonds',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': 'f458a9c7-966e-487f-813b-87b21cc412cd',
                                'libelle': 'Bilan_simplifie.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '5ea5b456-f072-468c-a912-93d7f9370948',
                                    'libelle': 'Comptabilite.Bilan_simplifie',
                                    'description': 'Bilan simplifie',
                                    'parent': {
                                        'id': 'b7474c5a-c302-4575-a7e8-ef7e52fdf464',
                                        'libelle': 'Comptabilite',
                                        'description': 'Comptabilite',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '341bed53-7215-4142-9162-fee635f0ae91',
                                'libelle': 'Portefeuille_du_fonds.Portefeuille_actif',
                                'description': 'Portefeuille actif',
                                'parent': {
                                    'id': '436f77b5-6ec1-4660-a0b6-5ba28e2d0c26',
                                    'libelle': 'Portefeuille_du_fonds',
                                    'description': 'Portefeuille du fonds',
                                    'parent': null
                                }
                            }, {
                                'id': 'cf9963d6-bc78-449a-a453-6f4daba0eb92',
                                'libelle': 'Audit.Gestion_des_logs_de_consultation',
                                'description': 'Gestion des logs de consultation',
                                'parent': {
                                    'id': 'a503c966-ec21-4a89-9703-bada3dfb37cf',
                                    'libelle': 'Audit',
                                    'description': 'Audit',
                                    'parent': null
                                }
                            }, {
                                'id': 'e8655d06-c680-4d97-94b0-1183e0cde4e6',
                                'libelle': 'Reserves.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': 'eb57884e-e8da-43c8-bedb-e3bf53afc1ba',
                                    'libelle': 'General.Reserves',
                                    'description': 'Reserves',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '923523a1-a06c-41e9-b2e2-5e9e7d9bc6a0',
                                'libelle': 'Template_des_fichiers_de_creances.Consulter',
                                'description': 'Consulter',
                                'parent': {
                                    'id': '6ced4355-e978-477f-a8db-9cd1ea7af901',
                                    'libelle': 'General.Template_des_fichiers_de_creances',
                                    'description': 'Template des fichiers de creances',
                                    'parent': {
                                        'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                        'libelle': 'Referentiel.General',
                                        'description': 'General',
                                        'parent': {
                                            'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                            'libelle': 'Referentiel',
                                            'description': 'Referentiel',
                                            'parent': null
                                        }
                                    }
                                }
                            }, {
                                'id': '6151d64e-98b8-4d53-b865-4e60c3e150e4',
                                'libelle': 'Etude_des_comptes.Edition_fiche_lab',
                                'description': 'Edition fiche lab',
                                'parent': {
                                    'id': '0927744e-5548-48e7-a847-733985dcbd20',
                                    'libelle': 'Investisseur.Etude_des_comptes',
                                    'description': 'Etude des comptes',
                                    'parent': {
                                        'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                        'libelle': 'Investisseur',
                                        'description': 'Investisseur',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '7708901d-ecbc-4166-ae4a-e21ea5a982e3',
                                'libelle': 'Gestion.Calcul',
                                'description': 'Calcul',
                                'parent': {
                                    'id': 'e8b3ee08-e760-41b5-9d5f-6214d2b1dd92',
                                    'libelle': 'Gestion',
                                    'description': 'Gestion',
                                    'parent': null
                                }
                            }, {
                                'id': '609f4174-5c82-4192-a92f-bce647bf8fc2',
                                'libelle': 'Etude_des_comptes.Validation',
                                'description': 'Validation',
                                'parent': {
                                    'id': '0927744e-5548-48e7-a847-733985dcbd20',
                                    'libelle': 'Investisseur.Etude_des_comptes',
                                    'description': 'Etude des comptes',
                                    'parent': {
                                        'id': '2249dd40-97d7-46fc-976e-64077b9a1a4a',
                                        'libelle': 'Investisseur',
                                        'description': 'Investisseur',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '064d44d7-1ff3-4b1f-8136-b812a8eceead',
                                'libelle': 'Administration.Strategie_de_mot_de_passe',
                                'description': 'Strategie de mot de passe',
                                'parent': {
                                    'id': '84eb7342-879f-41ab-9ca4-abfaac6ddf71',
                                    'libelle': 'Administration',
                                    'description': 'Administration',
                                    'parent': null
                                }
                            }, {
                                'id': 'c56df043-3801-42e0-b449-c5975cb57527',
                                'libelle': 'General.Evenements',
                                'description': 'Evenements',
                                'parent': {
                                    'id': '4d9b6f0c-dbd1-425b-8e75-4c002c451ff6',
                                    'libelle': 'Referentiel.General',
                                    'description': 'General',
                                    'parent': {
                                        'id': 'c60043b3-e343-4b3b-a949-ee46161f542b',
                                        'libelle': 'Referentiel',
                                        'description': 'Referentiel',
                                        'parent': null
                                    }
                                }
                            }, {
                                'id': '1bcc62a2-728f-489a-9fd1-72992f618cf1',
                                'libelle': 'Titre_de_creances.Modifier_un_placement',
                                'description': 'Modifier un placement',
                                'parent': {
                                    'id': '5f4e3b4f-58a9-4647-a5e1-3229593170be',
                                    'libelle': 'Placement_de_tresorerie.Titre_de_creances',
                                    'description': 'Titre de creances',
                                    'parent': {
                                        'id': '2d311df5-dfd2-4232-a4fa-d978d4077f53',
                                        'libelle': 'Placement_de_tresorerie',
                                        'description': 'Placement de tresorerie',
                                        'parent': null
                                    }
                                }
                            }]
                    }
                ],
                'permissions': [
                    'Administration', 'Administration.Gestion_des_habilitations', 'Administration.Strategie_de_mot_de_passe', 'Administration.Groupe_utilisateur', 'Administration.Utilisateur', 'Administration.Permission', 'Groupe_utilisateur.Ajouter', 'Permission.Consulter', 'Utilisateur.Supprimer', 'Opcvm.Saisir_un_placement_', 'Comptabilite', 'Jours_feries.Supprimer', 'Fonds.Waterfall', 'Portefeuille_du_fonds.Emission_de_titre', 'Utilisateur.Consulter', 'Frais_de_fonctionnement.Ajouter', 'Gestion_des_logs_de_consultation.Consulter', 'Frais_de_fonctionnement.Consulter', 'Jours_feries.Consulter', 'Reporting.Consulter', 'Opcvm.Modifier', 'Comptes.Supprimer', 'Fonds.Compartiment', 'General.Template_des_fichiers_de_creances', 'Criteres_d eligibilite.Ajouter', 'Criteres_d_eligibilite.Modifier', 'Evenements.Ajouter', 'Gestion_d_actif.Selection_de_creances', 'General.Creances', 'Investisseur', 'Waterfall.Consulter', 'Referentiel', 'Export.Reporting', 'Placement_de_tresorerie.Titre_de_creances', 'Utilisateur.Modifier', 'General.Jours_feries', 'Placement_de_tresorerie', 'Opcvm.Ajouter', 'Groupe_utilisateur.Supprimer', 'Parts_residuelles.Consulter', 'Dat.Passer_un_ordre', 'Titre_de_creances.Supprimer_un_placement', 'Opcvm.Supprimer_un_placement', 'Documents.Modifier', 'Gestion.Gestion_d_actif', 'Waterfall.Configurer', 'Groupe_utilisateur.Consulter', 'Investisseur.Souscription', 'Frais_de_fonctionnement.Supprimer', 'Comptes.Consulter', 'Portefeuille_du_fonds.Balance', 'Creances.Consulter', 'Export.Virement', 'Swap.Consulter', 'Documents.Supprimer', 'Titre_de_creances.Passer_un_ordre', 'Creances.Supprimer', 'Parts_residuelles.Modifier', 'Utilisateur.Ajouter', 'Criteres_d_eligibilite.Consulter', 'Investisseur.Balance', 'Creances.Ajouter', 'Bilan_simplifie.Exporter', 'Export', 'Dat.Modifier_un_placement', 'Tcn.Ajouter', 'General.Tranching', 'Swap.Ajouter', 'Reserves.Modifier', 'Portefeuille_du_fonds', 'Referentiel.Fonds', 'Type_operation.Modifier', 'Emission_de_titre.Saisie_d_ordre', 'Titres.Opcvm', 'Investisseur.Passif', 'Etat.Edition_de_portefeuille_parts_ou_titres', 'Creances.Modifier', 'Fonds.Documents', 'Calendrier_de_gestion.Modifier', 'Gestion_des_investisseurs.Consultation', 'General.Etablissements_bancaires', 'Fonds.Calendrier_de_gestion', 'Titres.Tcn', 'Audit', 'Opcvm.Passer_un_ordre', 'Export.Management_Report', 'Portefeuille_passif.Consulter', 'Rating.Consulter', 'Gestion', 'Virement.Consulter', 'Fonds.Comptes', 'Documents.Consulter', 'Fonds.Frais_de_fonctionnement', 'Gestion.Gestion_du_passif', 'Etude_des_comptes.Desactivation', 'Tcn.Supprimer', 'Calendrier_de_gestion.Consulter', 'General.Statistiques', 'Placement_de_tresorerie.Opcvm', 'General.Fichiers_de_creances', 'Placement_de_tresorerie.Dat', 'Tcn.Modifier', 'Type_operation.Supprimer', 'Tcn.Consulter', 'Titres.Parts_residuelles', 'Jours_feries.Modifier', 'Evenements.Supprimer', 'Calendrier_de_gestion.Ajouter', 'Titre_de_creances.Saisir_un_placement', 'Calcul.Nouveau_calcul', 'Type_operation.Consulter', 'Template_des_fichiers_de_creances.Configurer', 'Rating.Ajouter', 'Gestion_des_logs_de_validation.Consulter', 'Evenements.Consulter', 'Emission_de_titre.Modifier_un_ordre', 'Calendrier_de_gestion.Supprimer', 'General.Swaps', 'Swap.Modifier', 'Dat.Supprimer_un_placement', 'Controle_interne', 'General.Rating', 'Administration.Gestion_des_comptes_utilisateurs', 'Rating.Supprimer', 'Parts_residuelles.Ajouter', 'Gestion_des_investisseurs.Creation', 'Gestion_des_logs_de_validation.Exporter', 'Documents.Ajouter', 'Portefeuille_du_fonds.Portefeuille_passif', 'Investisseur.Actif', 'Investisseur.Etat', 'Etude_des_comptes.Rejet', 'Controle_interne.Controle', 'Reporting.Generer', 'Fonds.Garanties', 'Fonds.Criteres_d_eligibilite', 'Investisseur.Etude_des_comptes', 'Criteres_d_eligibilite.Supprimer', 'Gestion_d_actif.Pool_des_creances', 'Portefeuille_actif.Consulter', 'Comptabilite.Bilan_simplifie', 'Comptabilite.Consulter', 'General.Reserves', 'Fonds.General', 'Opcvm.Consulter', 'Waterfall.Modifier', 'Emission_de_titre.Consulter_titre', 'Gestion_des_logs_de_consultation.Exporter', 'General.Triggers', 'Reserves.Ajouter', 'Referentiel.Titres', 'Etat.Edition_de_releve_des_mouvements_des_comptes', 'Reserves.Supprimer', 'Opcvm.Supprimer', 'Audit.Gestion_des_logs_de_validation', 'Virement.Generer', 'Swap.Supprimer', 'Parts_residuelles.Supprimer', 'Comptes.Modifier', 'Type_operation.Ajouter', 'Opcvm.Modifier_un_placement', 'Investisseur.Gestion_des_investisseurs', 'Referentiel.General', 'Comptabilite.Generer', 'General.Type_operation', 'Tableau_de_bord', 'Template_des_fichiers_de_creances.Modifier', 'Gestion_des_investisseurs.Modification', 'Groupe_utilisateur.Modifier', 'Rating.Modifier', 'Etude_des_comptes.Activation', 'Export.Comptabilite', 'Evenements.Modifier', 'Frais_de_fonctionnement.Modifier', 'Comptes.Ajouter', 'Jours_feries.Ajouter', 'Investisseur.Gestion_des_comptes_investisseurs', 'Placement_de_tresorerie.Tresorerie_consolidee', 'Dat.Saisir_un_placement', 'Waterfall.Supprimer', 'Bilan_simplifie.Consulter', 'Portefeuille_du_fonds.Portefeuille_actif', 'Audit.Gestion_des_logs_de_consultation', 'Reserves.Consulter', 'Template_des_fichiers_de_creances.Consulter', 'Etude_des_comptes.Edition_fiche_lab', 'Gestion.Calcul', 'Etude_des_comptes.Validation', 'General.Evenements', 'Titre_de_creances.Modifier_un_placement'
                ]
            }
        }).pipe(
            map((reponse: HttpResponse<any>) => RequestUtilities.homogeneiserAdresseUtilisateurAuthentifie(reponse))
        );
        /*return this.restService.getRequest(`${WebUtilities.baseUrlApi()}authentifie`).pipe(
        map((reponse: HttpResponse<any>) => RequestUtilities.homogeneiserAdresseUtilisateurAuthentifie(reponse))
    );*/
    }

}
